import PollAnswer from './PollAnswer.js';

/**
 * @param ?string id
 * @param string question
 * @param PollAnswer[] answers
 * @param bool closed
 * @param number position
 */
export default class Poll
{
  constructor({
    id = null,
    question = '',
    answers = [],
    closed = false,
    position = 0,
  }) {
    this.id = id;
    this.question = question;
    this.answers = answers.map(item => new PollAnswer(item));
    this.closed = closed;
    this.position = position;
  }
};
